const WellBeingAnswerType = Object.freeze({
  RELATIVE: 1,
  STABILITY: 2,
  ABSOLUTE: 3
});

export default (WellBeingAnswerType);
